import React from 'react';
import webapi from '../../../api/webapi';
import Modal from 'react-bootstrap/Modal'
import Loading from '../modal/Loading';
//import Modal from "../modal/Modal";
//import reactStringReplace from 'react-string-replace'

class TagResultList extends React.Component {
    // state = { results : [] }
    // state = { word : '' }
    // //state = { modalshow: false};
    // state = { modalHeader : '' }
    // state = { modalText : '' }

    constructor(props) {
        super(props);
        //this.setState({ results: this.props.results });
        this.setState({ loadingShow: false })
    }

   
    showModal = async event => {
        event.preventDefault();
        this.setState({loadingShow:true});
        
        //console.log("id:",event.target.id);
        //if (!this.state.modalshow)
        {
            //console.log("url:",'sentence/detail/'+event.target.id);
            const responseText= await webapi.get('sentence/detail/'+event.target.id);
            //console.log("responseText:",responseText.data);
            if (responseText.data) this.setState({modalText:responseText.data});
            if ((responseText.data) && (responseText.data.Transcription))
            this.setState({modalHeader: responseText.data.Transcription});
            //alert(this.state.modalText);
        }
        //else
        //{
            //this.setState({modalText: '' });
        //}
        
       //console.log("modalText:",this.state.modalText);
        //console.log("modalshow:",this.state.modalshow);
        this.setState({loadingShow:false})
        this.setState({modalshow: true});
        //console.log("modalshow:",this.state.modalshow);
    };

    CloseModal = event => {
        event.preventDefault();
        this.setState({modalshow: false});
    }

    

    render() {
        //console.log("TagResultList/results:",this.props.results)
        if (this.props.results) {
            if (this.props.results.length>0) {
                return (
                    <div>
                        <div className="alert" role="alert">
                            {this.props.pageData.length!==0 && this.props.pageData[0].F29904!== undefined?this.props.pageData[0].F29904:29904/*"برای مشاهده برچسب‌های واژه روی شماره کلیک کنید"*/}
                        </div>
                    {
                        
                        this.props.results.map((result,j) =>{
                        return  (
                            <div className="tag_section">
                            <div className="ui segment" dir="ltr">
                                <form className="ui form">
                                    <div className="ui field" style={{lineHeight:'100%'}}>
                                        {
                                            //TextCode,Transcription,BookCode,BookTitle,Book,Sequence--,BookCode
                                        }
                                        <font size="4.5" face="Time">{result.Transcription}</font>
                                        <br/>
                                        {
                                            result.BookList.map(bookObject => (
                                                <div key={bookObject.BookCode} style={{float:'left',width:'100%',margin:'0px',marginBottom:'0px'}}>
                                                    <br/>
                                                    <div title={bookObject.BookTitle} style={{cursor:'pointer',float:'left'}}><font size="3">{bookObject.Book} :  </font></div>
                                                    {
                                                    // <h6>BookCode:{bookObject.BookCode}</h6>
                                                    // <h6>BookTitle:{bookObject.BookTitle}</h6>
                                                    // <h6>BookCode:{bookObject.BookCode}</h6>
                                                    }
                                                    {
                                                        bookObject.TextList.map((textObject,i) => (
                                                                /*(i===0) 
                                                                ?
                                                                (<a href="/#" key={textObject.TextCode} id={textObject.TextCode} onClick={event => {this.showModal(event)}} style={{cursor: 'pointer'}}>{textObject.Sequence}</a>)
                                                                :*/
                                                                (<a href="/#" key={textObject.TextCode} id={textObject.TextCode} onClick={event => {this.showModal(event)}} style={{cursor: 'pointer'}}> {textObject.Sequence}</a>)
                                                        ))
                                                    }
                                                </div>
                                            ))
                                        }
                                    </div>
                                </form>
                                {/* {
                                    (j===0 && this.state.modalText) 
                                    ?
                                    (<Modal onClose={this.CloseModal} 
                                            modalshow={this.state.modalshow}
                                            HeaderText={this.state.modalHeader}
                                            FooterText={""}
                                            modalText={this.state.modalText}
                                            >
                                                <table>
                                                    <tr>
                                                        <td>
                                                            <div className="Caption">Transcription: </div>
                                                        </td>
                                                        <td>
                                                            <div className="ltrData">{this.state.modalText.Transcription}</div>
                                                            </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div className="Caption">Transliteration:</div>
                                                        </td>
                                                        <td>
                                                            <div className="ltrData">{this.state.modalText.Transliteration}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div className="Caption">Translation:</div>
                                                        </td>    
                                                        <td>    
                                                            <div className="ltrDataFa">{this.state.modalText.Translation}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div className="Caption">Category:</div>
                                                        </td>    
                                                        <td>   
                                                            <div className="ltrDataFa">{this.state.modalText.Category}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div className="Caption">Lemma:</div>
                                                        </td>    
                                                        <td>    
                                                            <div className="ltrData">{this.state.modalText.Lemma}</div>
                                                        </td>
                                                    </tr>
                                                    <tr> 
                                                    <td>
                                                            <div className="Caption">Reference1:</div>
                                                        </td>    
                                                        <td>    
                                                            <div className="ltrData">{this.state.modalText.Reference1}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>   
                                                    <td>
                                                            <div className="Caption">Reference2:</div>
                                                        </td>    
                                                        <td>     
                                                            <div className="ltrData">{this.state.modalText.Reference2}</div>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <br />
                                                <div className="ltrData">
                                                        {
                                                            this.state.modalText.Paragraph.map(ParagraphItem =>{
                                                                return(
                                                                    (ParagraphItem.Text===this.state.modalHeader)
                                                                    ?
                                                                        (<span>{ParagraphItem.Text}</span>)
                                                                    :
                                                                        (ParagraphItem.Text)
                                                                )
                                                            })
                                                        }
                                                </div>
                                                <br />
                                                <div className="rtlDataFa">{this.state.modalText.ParagraphTranslation}</div>
                                    </Modal>
                                    )
                                    :
                                    null
                                } */}
                            </div>    
                            </div>  
                        )
                        })
                        
                    }
                    {
                        ((this.state) && (this.state.loadingShow))
                        ?
                        <Loading loadingShow={this.state.loadingShow} /> 
                        :
                        null
                    }
                    {
                        ((this.state) && (this.state.modalText)&& (this.state.modalText.Transcription))
                        ?
                        (
                            <Modal
                                show={this.state.modalshow}
                                onHide={() => this.setState({modalshow: false})}
                                dialogClassName="modal-90w"
                                aria-labelledby="modal-styling-title"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="modal-styling-title">
                                        
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div className="Caption">Transcription:</div>
                                                </td>
                                                <td>
                                                    <div className="ltrData">{this.state.modalText.Transcription}</div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="Caption">Transliteration:</div>
                                                </td>
                                                <td>
                                                    <div className="ltrData">{this.state.modalText.Transliteration}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="Caption">Translation1:</div>
                                                </td>    
                                                <td>    
                                                    <div className="ltrDataFa">{this.state.modalText.Translation}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="Caption">Translation2:</div>
                                                </td>    
                                                <td>    
                                                    <div className="ltrDataFa">{this.state.modalText.EnTranslation}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="Caption">Category:</div>
                                                </td>    
                                                <td>   
                                                    <div className="ltrDataFa">{this.state.modalText.Category}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="Caption">Lemma:</div>
                                                </td>    
                                                <td>    
                                                    <div className="ltrData">{this.state.modalText.Lemma}</div>
                                                </td>
                                            </tr>
                                            <tr> 
                                            <td>
                                                    <div className="Caption">Reference1:</div>
                                                </td>    
                                                <td>    
                                                    <div className="ltrData">{this.state.modalText.Reference1}</div>
                                                </td>
                                            </tr>
                                            <tr>   
                                                <td>
                                                    <div className="Caption">Reference2:</div>
                                                </td>    
                                                <td>     
                                                    <div className="ltrData">{this.state.modalText.Reference2}</div>
                                                </td>
                                            </tr>
                                            <tr>   
                                                <td>
                                                    <div className="Caption">Note:</div>
                                                </td>    
                                                <td>     
                                                    <div className="ltrData">{this.state.modalText.Note}</div>
                                                </td>
                                            </tr>   
                                        </tbody>
                                    </table>
                                    <br />
                                    <div className="ltrData">
                                            {
                                                this.state.modalText.Paragraph.map(ParagraphItem =>{
                                                    return(
                                                        (ParagraphItem.Text===this.state.modalHeader)
                                                        ?
                                                            (<span className='HighLight'>{ParagraphItem.Text}</span>)
                                                        :
                                                            (ParagraphItem.Text)
                                                    )
                                                })
                                            }
                                    </div>
                                    <br />
                                    <div className="rtlDataFa">{this.state.modalText.ParagraphTranslation}</div>
                                    <div className="rtlDataFaNote">{this.state.modalText.ParagraphNote}</div>
                                </Modal.Body>
                            </Modal>
                        )
                        :
                        <></>
                    }
                    </div>
                ) 
            }
            else
            {
                return (<div>{this.props.pageData.length!==0 && this.props.pageData[0].F29903!== undefined?this.props.pageData[0].F29903:29903/*"موردی یافت نشد"*/}</div>)
            }
        }
        else
        {
            return (<div></div>)
        } 
    }
}


export default TagResultList;